define("mage/url",[],function(){var n="";return{setBaseUrl:function(e){n=e},build:function(e){return-1!==e.indexOf(n)?e:n+e}}});
